export const LanguageCode = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  SIMPLIFIED_CHINESE: 'zh-CN',
  TRADITIONAL_CHINESE: 'zh-TW',
  THAI: 'th',
  CASTILIAN: 'es',
  VIETNAMESE: 'vi',
  KOREAN: 'ko',
  FRENCH: 'fr',
  GERMAN: 'de',
  INDONESIAN: 'id',
} as const

export enum LanguageCodeEnum {
  JAPANESE = 'ja',
  ENGLISH = 'en',
  SIMPLIFIED_CHINESE = 'zh-CN',
  TRADITIONAL_CHINESE = 'zh-TW',
  THAI = 'th',
  CASTILIAN = 'es',
  VIETNAMESE = 'vi',
  KOREAN = 'ko',
  FRENCH = 'fr',
  GERMAN = 'de',
  INDONESIAN = 'id',
}

export type LanguageCode = typeof LanguageCode[keyof typeof LanguageCode]

export const languageLabel = (name: LanguageCode): string => {
  switch (name) {
    case 'ja':
      return '日本語'
    case 'en':
      return 'English'
    case 'zh-CN':
      return '简体中文'
    case 'zh-TW':
      return '繁體中文'
    case 'es':
      return 'Español'
    case 'th':
      return 'อักษรไทย'
    case 'vi':
      return 'tiếng Việt'
    case 'ko':
      return '한국어'
    case 'fr':
      return 'Français'
    case 'de':
      return 'Deutsch'
    case 'id':
      return 'Indonesia'
  }
}

export const LANGUAGE_LABELS: Record<LanguageCode, string> = {
  'ja': '日本語',
  'en': 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'es': 'Español',
  'th': 'อักษรไทย',
  'vi': 'tiếng Việt',
  'ko': '한국어',
  'fr': 'Français',
  'de': 'Deutsch',
  'id': 'Indonesia',
} as const

export const LANGUAGE_JAPANESE_LABELS: Record<LanguageCode, string> = {
  'ja': '日本語',
  'en': '英語',
  'zh-CN': '中国語（簡体字）',
  'zh-TW': '中国語（繁体字）',
  'es': 'スペイン語',
  'th': 'タイ語',
  'vi': 'ベトナム語',
  'ko': '韓国語',
  'fr': 'フランス語',
  'de': 'ドイツ語',
  'id': 'インドネシア語',
} as const

export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_LABELS).map(
  ([value, title]) => ({ value: String(value), title }),
) as { title: string, value: LanguageCode }[]

export const PRIMARY_LANGEAGE_OPTIONS = LANGUAGE_OPTIONS.filter(
  option => option.value === 'ja' || option.value === 'en',
) as { title: string, value: LanguageCode }[]

export const LANGUAGE_JAPANESE_OPTIONS = Object.entries(LANGUAGE_JAPANESE_LABELS).map(
  ([value, title]) => ({ value: String(value), title }),
) as { title: string, value: LanguageCode }[]
